var _rect, _title, _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptybox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 444,
    height: 308,
    preserveAspectRatio: "xMidYMid meet",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,308) scale(0.10000000149011612,-0.10000000149011612) ",
    fill: "#4fc2f7",
    stroke: "none",
    id: "svg_1",
    className: "",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1275 3043 c-242 -84 -394 -299 -395 -555 0 -64 -3 -77 -17 -82 -10 -3 -130 -28 -267 -56 -138 -28 -251 -52 -253 -53 -15 -15 -333 -785 -331 -801 3 -23 12 -26 211 -66 l107 -23 0 -496 c0 -273 4 -502 9 -510 8 -13 1825 -391 1881 -391 56 0 1873 378 1881 391 5 8 9 237 9 510 l0 496 108 23 c200 41 207 43 210 67 2 16 -316 785 -332 800 -1 2 -423 89 -937 193 l-934 191 -85 -16 c-47 -9 -92 -18 -101 -21 -12 -3 -21 10 -37 53 -57 156 -179 278 -340 340 -55 22 -88 27 -187 30 -111 3 -126 2 -200 -24z m287 -47 c186 -40 338 -181 392 -365 18 -62 21 -193 5 -261 -18 -78 -71 -172 -134 -236 -270 -275 -740 -163 -856 205 -29 93 -29 224 1 311 32 95 102 194 174 247 80 59 104 71 189 93 87 23 141 24 229 6z m628 -726 c0 -313 -1 -330 -18 -330 -20 0 -363 68 -368 73 -2 2 23 29 56 61 118 116 170 234 178 403 l5 101 46 10 c25 5 58 10 74 11 l27 1 0 -330z m893 168 c438 -90 797 -165 797 -168 0 -5 -1596 -332 -1617 -331 -10 1 -13 74 -13 331 0 308 1 330 18 330 9 0 376 -73 815 -162z m-2159 -165 c15 -38 29 -73 32 -79 3 -6 -79 6 -195 30 -111 23 -201 43 -201 46 0 6 281 67 316 69 16 1 26 -13 48 -66z m-218 -107 l310 -63 65 -52 c164 -133 370 -173 561 -111 l66 22 229 -47 c125 -26 229 -48 231 -50 1 -1 -65 -159 -147 -351 -94 -220 -155 -348 -163 -347 -28 4 -1763 357 -1767 359 -4 4 293 704 299 704 3 0 145 -29 316 -64z m3496 -286 c82 -190 148 -347 148 -350 0 -3 -93 -24 -207 -47 -115 -23 -505 -103 -868 -177 -363 -74 -670 -136 -683 -138 -22 -3 -34 21 -173 346 -82 192 -148 350 -147 352 6 5 1754 362 1768 360 9 -1 68 -126 162 -346z m-2019 -1791 c-5 -4 -125 17 -268 46 -143 30 -537 111 -875 180 -338 69 -621 127 -627 130 -10 3 -13 108 -13 475 0 258 2 470 5 470 3 0 339 -68 747 -151 470 -96 747 -148 756 -143 7 5 65 131 128 279 64 149 123 286 132 305 16 33 17 -8 20 -774 1 -446 -1 -813 -5 -817z m210 1311 c69 -162 132 -299 140 -304 8 -5 285 47 755 143 408 83 744 151 747 151 3 0 5 -212 5 -470 0 -367 -3 -472 -12 -475 -7 -3 -290 -61 -628 -130 -338 -69 -732 -150 -875 -179 -143 -30 -263 -52 -267 -49 -5 2 -8 369 -8 816 0 483 4 807 9 802 5 -6 66 -143 134 -305z",
    id: "svg_2",
    fill: "#4fc2f7",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1342 2948 c-9 -9 -12 -82 -12 -269 0 -142 3 -264 6 -273 9 -24 239 -24 248 0 3 9 6 131 6 273 0 187 -3 260 -12 269 -8 8 -49 12 -118 12 -69 0 -110 -4 -118 -12z m178 -278 l0 -220 -60 0 -60 0 0 220 0 220 60 0 60 0 0 -220z",
    id: "svg_3",
    fill: "#4fc2f7",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423 2309 c-50 -14 -83 -62 -83 -118 0 -53 18 -84 60 -106 88 -45 180 13 180 114 0 60 -39 101 -110 116 -8 2 -29 -1 -47 -6z m63 -67 c6 -4 16 -17 23 -30 27 -52 -46 -96 -91 -55 -24 21 -23 48 2 73 21 21 47 25 66 12z",
    id: "svg_4",
    fill: "#4fc2f7",
    fillOpacity: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4fc2f7",
    fillOpacity: 0,
    stroke: "#ff5bde",
    strokeOpacity: 1,
    strokeWidth: 8,
    strokeDasharray: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    d: "M91.15976199577773,58.73372745513916 C91.15976199577773,28.346987123647448 115.73197766467598,3.73372745513916 146.06804639171088,3.73372745513916 C176.40411511874575,3.73372745513916 200.97633078764403,28.346987123647448 200.97633078764403,58.73372745513916 C200.97633078764403,89.12046778663087 176.40411511874575,113.73372745513916 146.06804639171088,113.73372745513916 C115.73197766467598,113.73372745513916 91.15976199577773,89.12046778663087 91.15976199577773,58.73372745513916 z",
    className: "",
    id: "svg_8"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4fc2f7",
    fillOpacity: 1,
    stroke: "#ff5bde",
    strokeOpacity: 1,
    strokeWidth: 6,
    strokeDasharray: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    id: "svg_5",
    rx: 0,
    ry: 0,
    cx: 37,
    cy: 72,
    style: {
      color: "rgb(79, 194, 247)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#102c38",
    fillOpacity: 1,
    stroke: "#1a1aeb",
    strokeOpacity: 1,
    strokeWidth: 6,
    strokeDasharray: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 0,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    d: "M88,155 C88,124.61325966850829 129.17127071823205,100 180,100 C230.82872928176795,100 272,124.61325966850829 272,155 C272,185.38674033149172 230.82872928176795,210 180,210 C129.17127071823205,210 88,185.38674033149172 88,155 Z",
    id: "svg_6"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    stroke: "#ff5bde",
    strokeWidth: 6,
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    id: "svg_9",
    x: 136.1420135498047,
    y: 15.142011642456055,
    width: 20,
    height: 53,
    style: {
      color: "rgb(255, 255, 255)"
    },
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4fc2f7",
    stroke: "#ff5bde",
    strokeWidth: 5,
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    x: 136.1420135498047,
    y: 15.142011642456055,
    width: 20,
    height: 53,
    style: {
      color: "rgb(255, 255, 255)"
    },
    className: "",
    id: "svg_12",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#4fc2f7",
    stroke: "#ff5bde",
    strokeWidth: 5,
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    x: 135.55029755830765,
    y: 15.142011642456055,
    width: 21.775147914886475,
    height: 54.775150179862976,
    style: {
      color: "rgb(255, 255, 255)"
    },
    className: "",
    fillOpacity: 1,
    id: "svg_7"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4fc2f7",
    fillOpacity: 1,
    stroke: "#ff5bde",
    strokeOpacity: 1,
    strokeWidth: 5,
    strokeDasharray: "none",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeDashoffset: "",
    fillRule: "nonzero",
    opacity: 1,
    markerStart: "",
    markerMid: "",
    markerEnd: "",
    d: "M135.3668630034186,88.84615359134062 C135.3668630034186,82.9551470681853 140.13857779725848,78.1834317844295 146.02958371557935,78.1834317844295 C151.92058963390022,78.1834317844295 156.6923044277401,82.9551470681853 156.6923044277401,88.84615359134062 C156.6923044277401,94.73716011449594 151.92058963390022,99.50887539825175 146.02958371557935,99.50887539825175 C140.13857779725848,99.50887539825175 135.3668630034186,94.73716011449594 135.3668630034186,88.84615359134062 z",
    id: "svg_10",
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptybox);
export default __webpack_public_path__ + "static/media/emptybox.961a87433ee80435734a953f86a98a72.svg";
export { ForwardRef as ReactComponent };